import { downloadFile } from './helpers/download-file';

export const downloadImage = downloadFile;
